import { useMutation } from '@sequencehq/api/utils'
import { dashboard20240730Client } from '@sequencehq/api/dashboard/v20240730'
import { useQueryClient } from '@tanstack/react-query'
import { dashboardv99990101Client } from '@sequencehq/api/dashboard/v99990101'

export const useCreateInvoice = () => {
  const queryClient = useQueryClient()
  const { mutateAsync } = useMutation(dashboard20240730Client.postInvoice, {
    onSuccess: data => {
      queryClient.setQueryData(
        [...dashboardv99990101Client.getInvoice.queryKey, { id: data?.id }],
        data
      )
    }
  })

  return mutateAsync
}
